module.exports = __webpack_public_path__ + "img/NewMotoIcon.a3e45691.svg";